import React from 'react';
import { AppModalAction, ModalActions } from '@cp/ds/src/components/modalLayout';
import { Box } from '@cp/ds/src/components/box';
import { FormField } from '@cp/ds/src/components/form';
import { FormProvider } from 'react-hook-form';
import { useConfig } from '@cp/shared/config';
import { SmartCaptcha } from 'src/entities/smartCaptcha';
import { LoginStrategy } from '../../model';
import { ViewProps } from './types';

export const View: React.FC<ViewProps> = ({ loginStrategy, form, onSubmit, sx }) => {
  const {
    handleSubmit,
    setValue,
    watch,
    formState: { isSubmitting, isValid },
  } = form;
  const token = watch('smartToken');
  const config = useConfig();
  const captchaEnabled = config.get('SMART_CAPTCHA_ENABLED', false);

  const actions = React.useMemo<AppModalAction[]>(
    () => [
      {
        title: 'Получить код', // ToDo: replace with translated string
        variant: 'primary',
        color: 'gray',
        buttonProps: {
          disabled: isSubmitting || !isValid || (captchaEnabled && !token),
          type: 'submit',
          sx: {
            width: 1,
            whiteSpace: { sm: 'nowrap' },
          },
        },
      },
    ],
    [isValid, isSubmitting, captchaEnabled, token],
  );

  return (
    <FormProvider {...form}>
      <Box component="form" noValidate onSubmit={handleSubmit(onSubmit)} sx={sx}>
        {loginStrategy === LoginStrategy.Phone ? (
          <FormField autoFocus name="phoneNumber" placeholder="Телефон" required type="phone" />
        ) : (
          <FormField autoFocus name="email" placeholder="Почта" required type="email" />
        )}
        {captchaEnabled && (
          <Box sx={{ mt: 2, display: isValid ? 'block' : 'none' }}>
            <SmartCaptcha onSuccess={(t) => setValue('smartToken', t)} />
          </Box>
        )}
        <ModalActions actions={actions} sx={{ mt: 4, px: 0 }} />
      </Box>
    </FormProvider>
  );
};
